import { Box } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

import Body from './components/Body';
import Header from './components/Header';

interface GraphParts {
  Body: typeof Body;
  Header: typeof Header;
}

type BoxProps = React.ComponentProps<typeof Box>;

const Graph: FCWithChildren<BoxProps> & GraphParts = (props) => (
  <Box
    border="1px solid"
    borderColor="grey.300"
    borderRadius="radius-8"
    height="100%"
    paddingBottom="space-12"
    width="100%"
    {...props}
  />
);

Graph.Body = Body;
Graph.Header = Header;

export default Graph;
